(function DestinationContent($, Adzuki)
{
	"use strict";

	var DestinationContent = {};

	DestinationContent.section_tops = {};

	DestinationContent.init = function init()
	{
		var destination_id              = null;
		var $gallery_btn                = $('#destination-content-images');
		var destination_content_gallery = null;
		var nav_items                   = $('.destination_guide_nav_item');

		$gallery_btn.click(function onGalleryClick()
		{
			if (destination_content_gallery) {
				destination_content_gallery.openGallery();
			}
		});

		// if there are destination images
		if ($('#destination-content-images').length > 0) {
			destination_id = $('#destination-content-images').data('destination-id');
			Adzuki.Ajax.post('/DestinationContents/getDestinationImages/' + destination_id)
			.then(function sucess(response) {
				var images         = response;
				var gallery_images = [];

				if (images.length === 0) {
					return;
				}

				$.each(images, function onEachImage(i, image) {
					gallery_images.push({
						src    : image.url,
						thumb  : image.url,
						subHtml: image.caption,
					});
				});

				destination_content_gallery = lightGallery($gallery_btn[0], {
					licenseKey       : 'github',
					download         : false,
					plugins          : [lgThumbnail],
					dynamic          : true,
					thumbnail        : true,
					toggleThumb      : true,
					allowMediaOverlap: true,
					dynamicEl        : gallery_images,
				});
			});
		}

		if ($('#destination-contents .read_more')) {
			$('#destination-contents .read_more').on('click', function readMore(ev) {
				var data_id = $(this).data('id');
				var type    = $(this).data('type');

				$('#' + type + '-snippet-' + data_id).addClass('hidden');
				$('#' + type + '-full-details-' + data_id).removeClass('hidden');

				ev.preventDefault();
			});
			$('#destination-contents .show_less').on('click', function showLess(ev) {
				var data_id = $(this).data('id');
				var type    = $(this).data('type');

				$('#' + type + '-full-details-' + data_id).addClass('hidden');
				$('#' + type + '-snippet-' + data_id).removeClass('hidden');

				ev.preventDefault();
			});
		}

		// Links within activities, tips, and features should open in new tab
		$('.activity-full-details a, .tip-full-details a, .feature-full-details a').each(function addTarget(index, el) {
			$(el).attr('target', '_blank');
		});

		$('.destination_guide_nav_item').each(function mapSections(index, element) {
			var section_name           = $(element).data('section');
			DestinationContent.section_tops[section_name] = $('#' + section_name).position().top;
		});

		nav_items.on('click', this.scrollToSection);

		this.populatePoiMap();
		this.populateDescription();
		this.autoDetermineNavLink();
	};

	// When user clicks an item in right nav, scroll them to that sectio and highlight nav link
	DestinationContent.scrollToSection = function scrollToSection(ev)
	{
		var section_name = $(this).data('section');

		ev.preventDefault();

		// Temporarily disable the JS that re-displays website header when user scrolls up
		$('#ignore_display_header').val('1');

		// Disable the scroll handler that auto-determines which nav section to highlight
		// Because we're going to manually set it based on user click
		$(document).off('scroll', DestinationContent.determineSection);

		// After 900 ms, re-enable the JS that re-displays website header when user scrolls up
		setTimeout(
			function enableScrollHeader() { 
				$('#ignore_display_header').val('0');
				$(document).on('scroll', DestinationContent.determineSection); // re-enable automatically detecting section by scroll
			},
			900
		);

		$('html, body').animate({
			scrollTop: $('#' + section_name).offset().top
		}, 600);
		DestinationContent.highlightNavLink(section_name); // manually select nav link
	};

	// Populate the google map
	DestinationContent.populatePoiMap = function populatePoiMap()
	{
		var map = {},
		    data = null;

		if ($('.poi-map').length > 0) {
			map  = new Adzuki.Map('.poi-map', {zoom: 13});
			data = $(".poi-map").data('results');

			map.populate(data.map);
		}
	};

	// If there is a destintion_guides record, grab description and populate on page
	DestinationContent.populateDescription = function populateDescription()
	{
		var parent = window.parent,
		description = parent.document.getElementById('destinationcontentaction-description'),
		description_text = null;

		if (description) {
			description_text = description.value.trim();
			$("#guide-description-text").html(description_text);
			if (description_text === '') {
				$('#guide-description').addClass('hidden');
			} else {
				$('#guide-description').removeClass('hidden');
			}
		}
	};

	// Attach event handler for handling user scrolling and auto-selecting nav link
	DestinationContent.autoDetermineNavLink = function autoDetermineNavLink()
	{
		$(document).on('scroll', DestinationContent.determineSection);
	};

	// Determine where user is on screen based on scrollTop and highlight the 
	// approprite link in the navigation sidebar
	DestinationContent.determineSection = function determineSection() {
		var pageScrollTop    = $(this).scrollTop() + 100;
		var last_scrolled_to = null;
		var section_name;

		for (section_name in DestinationContent.section_tops) {
			if (DestinationContent.section_tops[section_name] <= pageScrollTop) {
				last_scrolled_to = section_name;
			}
		}

		if (last_scrolled_to !== null) {
			DestinationContent.highlightNavLink(last_scrolled_to);
		}
	};

	// Unselect all side nav links and select the passed in nav link
	DestinationContent.highlightNavLink = function highlightNavLink(section_name)
	{
		$('.destination_guide_nav_item').removeClass('selected');
		$('.destination_guide_nav_item[data-section=' + section_name +']').addClass('selected');
	};

	$(document).ready(function documentReady()
	{
		Adzuki.DestinationContent = DestinationContent;
		Adzuki.onload('DestinationContents/DestinationGuide', function onload() {
			Adzuki.DestinationContent.init();
		});
	});

}(jQuery, window.Adzuki || {}));